import React from 'react'
import { Outlet } from 'react-router-dom';

const SimpleLayout = () => {
  return (
    <div style={{background:'steelblue'}}>
        <Outlet />
    </div>
  )
}

export default SimpleLayout